module.exports = __webpack_public_path__ + "img/image1.ffa949e5.png";